<button mat-icon-button (click)="closeDialog()" *ngIf="data.showCloseButton">
    <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
</button>
<order-list [pos]="pos"
            [orders]="pos.orders"
            (payClicked)="closeDialog()"
            (closeButtonClicked)="closeDialog()"
            (orderTotalChanged)="updateOrderTotal($event)"
            [isMobileResolution]="true">
</order-list>

